module.exports = __webpack_public_path__ + "images/thumb-db024646ccf0ec801f0e480be4806bcd.jpg";